import React from 'react';
import PropTypes from 'prop-types';

import {
  SR_APPLICATION_ASSEMBLY_LINE_STATUSES,
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED,
} from 'common/applicationAssemblyLineConstants';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import { formatPrice } from 'common/formatters';

const SrIncomeVerificationTotalCardAssemblyLine = ({ amount, status }) => {
  let amountColor = 'fontBlueDark';
  const amountFormatted = amount ? formatPrice(amount) : '$-';
  const isQualified = status === SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED;
  const borderColor = isQualified ? '#00A238' : '#D4D6D8';
  const backgroundColor = isQualified ? '#EBF8EF' : 'white';
  const borderColorStatus = `1px solid ${borderColor}`;

  if (isQualified) {
    amountColor = 'green';
  }

  return (
    <SrFlex
      padding="16px"
      direction="col"
      borderRadius="7px"
      justify="center"
      backgroundColor={backgroundColor}
      border={borderColorStatus}
    >
      <SrBox margin="0 auto 8px">
        <SrText
          font="greycliff"
          weight="800"
          fontSize="28px"
          lineHeight="34px"
          letterSpacing="1px"
          color={amountColor}
        >
          {amountFormatted}
        </SrText>
      </SrBox>
      <SrBox margin="0 auto">
        <SrText font="greycliff" weight="700" fontSize="16px" lineHeight="19px">
          Monthly Income
        </SrText>
      </SrBox>
    </SrFlex>
  );
};

SrIncomeVerificationTotalCardAssemblyLine.propTypes = {
  status: PropTypes.oneOf(SR_APPLICATION_ASSEMBLY_LINE_STATUSES).isRequired,
  amount: PropTypes.number,
};

SrIncomeVerificationTotalCardAssemblyLine.displayName = 'SrIncomeVerificationTotalCardAssemblyLine';

export default SrIncomeVerificationTotalCardAssemblyLine;
